import authorizedAPIInstance from '@/api/authorizedAPI';
import type {
  BackfillExecutionDTOResponse,
  BackfillExecutionParams,
  BackfillExecutionsResponse,
  PostBackfillRequest,
} from '@/features/backfill/types/backfill.types';
import { mapBackFillDTO } from '@/features/backfill/utils/backfill.mapper';

export const getBackFillList = async (params: BackfillExecutionParams) => {
  const { data } =
    await authorizedAPIInstance.get<BackfillExecutionDTOResponse>(
      `/soft-tag/${params?.soft_tag_id}/backfill-executions`,
      {
        params: params,
      }
    );

  const response: BackfillExecutionsResponse = mapBackFillDTO(data);
  return response;
};

export const postBackfill = async (requestData: PostBackfillRequest) => {
  const params = {
    start_time: requestData?.startTime,
    end_time: requestData?.endTime,
    extra_fields: requestData?.extraFields,
    batch_size: requestData?.batchSize,
    retry_count: requestData?.retryCount,
  };
  const { data } = await authorizedAPIInstance.post(
    `/soft-tag/${requestData?.soft_tag_id}/backfill`,
    params
  );
  return data;
};
